const listeners = new Set();

/** Notifies the history guard when overlay or page-back handlers appear or disappear. */
export function subscribeBackIntentChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function notifyBackIntentChange() {
  listeners.forEach((fn) => fn());
}

export function resetBackIntentBusForTests() {
  listeners.clear();
}
